export default __webpack_public_path__ + "static/media/abstracto-plus-logo.11b1b3d5.svg";